// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"video-camera"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M1 5H16V19H1V5Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M16 10.2L23 6V18L16 13.8V10.2Z"}},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M16 10.2L23 5.99997V18L16 13.8V10.2Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M1 5H16V19H1V5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]}]};

const VideoCameraIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'video-camera',
    ref,
    icon: element,
  },
));

VideoCameraIcon.displayName = 'VideoCameraIcon';

export default VideoCameraIcon;
